import React from "react";
import ProductGrid from "./components/ProductGrid";

function Breakouts_acne() {
  return <ProductGrid params={{ skinConcern: "acne" }} />;
}

export default Breakouts_acne;
